import { Controller } from "@hotwired/stimulus"

// This Stimulus controller watches changes to the account type multiselect
// and updates the partner workflows section dynamically using Turbo Frames.
export default class extends Controller {
  static values = {
    jobId: String
  }

  connect() {
    this.lastSelectionKey = ''

    // Listen for the chooser select change event
    this.boundHandleAccountTypeChange = this.handleAccountTypeChange.bind(this)
    document.addEventListener("chooser_select:change", this.boundHandleAccountTypeChange)

    // Also set up a mutation observer to watch for changes in the input container
    const inputContainer = document.querySelector('[data-chooser-select-target="selected"]')
    if (inputContainer) {
      this.observer = new MutationObserver(this.handleAccountTypeChange.bind(this))
      this.observer.observe(inputContainer, {
        childList: true,
        subtree: true
      })
    }

    // Set up periodic checking as a fallback
    this.periodicCheck = setInterval(this.handleAccountTypeChange.bind(this), 2000)
  }

  disconnect() {
    // Clean up event listener
    document.removeEventListener("chooser_select:change", this.boundHandleAccountTypeChange)

    // Clean up mutation observer
    if (this.observer) {
      this.observer.disconnect()
    }

    // Clean up periodic check
    if (this.periodicCheck) {
      clearInterval(this.periodicCheck)
    }
  }

  // Handle changes to the account type selection
  async handleAccountTypeChange(event) {
    // Small delay to ensure DOM is updated
    await new Promise(resolve => setTimeout(resolve, 100))

    const accountTypeIds = this.getSelectedAccountTypeIds()
    const selectionKey = accountTypeIds.sort().join(',')

    // Check if this is the same selection as last time
    if (this.lastSelectionKey === selectionKey) {
      return
    }

    // Store the current selection key
    this.lastSelectionKey = selectionKey

    // Update the turbo frame with the new account type IDs
    this.updatePartnerWorkflowsFrame(accountTypeIds)
  }

  // Get all currently selected account type IDs
  getSelectedAccountTypeIds() {
    const accountTypeInputs = document.querySelectorAll("input[name='job[account_type_ids][]']")
    return Array.from(accountTypeInputs).map(input => input.value)
  }

  // Update the partner workflows frame with new account type IDs
  updatePartnerWorkflowsFrame(accountTypeIds) {
    const frame = document.getElementById("partner_workflows_frame")
    if (frame) {
      // Build URL with account type IDs as params
      let url = `/admin/jobs/${this.jobIdValue}/partner_workflows_frame`
      if (accountTypeIds.length > 0) {
        const params = new URLSearchParams()
        accountTypeIds.forEach(id => params.append('account_type_ids[]', id))
        url += `?${params.toString()}`
      }

      frame.src = url
    }
  }
}
